declare namespace $ {

	type $mol_textarea__hint_shm_hitalama_map_widget_float_settings_table_1 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_textarea['hint'] >
	>
	type $mol_textarea__value_shm_hitalama_map_widget_float_settings_table_2 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_settings_table['headers_text'] >
		,
		ReturnType< $mol_textarea['value'] >
	>
	type $mol_textarea__spellcheck_shm_hitalama_map_widget_float_settings_table_3 = $mol_type_enforce<
		boolean
		,
		ReturnType< $mol_textarea['spellcheck'] >
	>
	type $mol_labeler__title_shm_hitalama_map_widget_float_settings_table_4 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_labeler['title'] >
	>
	type $mol_labeler__Content_shm_hitalama_map_widget_float_settings_table_5 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_settings_table['Headers'] >
		,
		ReturnType< $mol_labeler['Content'] >
	>
	type $mol_textarea__hint_shm_hitalama_map_widget_float_settings_table_6 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_textarea['hint'] >
	>
	type $mol_textarea__sidebar_showed_shm_hitalama_map_widget_float_settings_table_7 = $mol_type_enforce<
		boolean
		,
		ReturnType< $mol_textarea['sidebar_showed'] >
	>
	type $mol_textarea__value_shm_hitalama_map_widget_float_settings_table_8 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_settings_table['head_code'] >
		,
		ReturnType< $mol_textarea['value'] >
	>
	type $mol_textarea__spellcheck_shm_hitalama_map_widget_float_settings_table_9 = $mol_type_enforce<
		boolean
		,
		ReturnType< $mol_textarea['spellcheck'] >
	>
	type $mol_labeler__title_shm_hitalama_map_widget_float_settings_table_10 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_labeler['title'] >
	>
	type $mol_labeler__Content_shm_hitalama_map_widget_float_settings_table_11 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_settings_table['Head_code'] >
		,
		ReturnType< $mol_labeler['Content'] >
	>
	type $mol_textarea__hint_shm_hitalama_map_widget_float_settings_table_12 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_textarea['hint'] >
	>
	type $mol_textarea__sidebar_showed_shm_hitalama_map_widget_float_settings_table_13 = $mol_type_enforce<
		boolean
		,
		ReturnType< $mol_textarea['sidebar_showed'] >
	>
	type $mol_textarea__value_shm_hitalama_map_widget_float_settings_table_14 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_settings_table['rows_code'] >
		,
		ReturnType< $mol_textarea['value'] >
	>
	type $mol_textarea__spellcheck_shm_hitalama_map_widget_float_settings_table_15 = $mol_type_enforce<
		boolean
		,
		ReturnType< $mol_textarea['spellcheck'] >
	>
	type $mol_labeler__title_shm_hitalama_map_widget_float_settings_table_16 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_labeler['title'] >
	>
	type $mol_labeler__Content_shm_hitalama_map_widget_float_settings_table_17 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_settings_table['Rows_code'] >
		,
		ReturnType< $mol_labeler['Content'] >
	>
	type $mol_number__value_shm_hitalama_map_widget_float_settings_table_18 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_settings_table['rows_limit'] >
		,
		ReturnType< $mol_number['value'] >
	>
	type $mol_number__hint_shm_hitalama_map_widget_float_settings_table_19 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_number['hint'] >
	>
	type $mol_number__precision_shm_hitalama_map_widget_float_settings_table_20 = $mol_type_enforce<
		number
		,
		ReturnType< $mol_number['precision'] >
	>
	type $mol_number__precision_change_shm_hitalama_map_widget_float_settings_table_21 = $mol_type_enforce<
		number
		,
		ReturnType< $mol_number['precision_change'] >
	>
	type $mol_form_field__name_shm_hitalama_map_widget_float_settings_table_22 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_form_field['name'] >
	>
	type $mol_form_field__Content_shm_hitalama_map_widget_float_settings_table_23 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_settings_table['Rows_limit'] >
		,
		ReturnType< $mol_form_field['Content'] >
	>
	type $shm_check_list__options_shm_hitalama_map_widget_float_settings_table_24 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_settings_table['column_visibility_options'] >
		,
		ReturnType< $shm_check_list['options'] >
	>
	type $shm_check_list__value_shm_hitalama_map_widget_float_settings_table_25 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_settings_table['columns_visible'] >
		,
		ReturnType< $shm_check_list['value'] >
	>
	type $mol_form_field__name_shm_hitalama_map_widget_float_settings_table_26 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_form_field['name'] >
	>
	type $mol_form_field__Content_shm_hitalama_map_widget_float_settings_table_27 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_settings_table['Columns_visibility'] >
		,
		ReturnType< $mol_form_field['Content'] >
	>
	export class $shm_hitalama_map_widget_float_settings_table extends $shm_hitalama_map_widget_float_settings {
		headers_text( next?: string ): string
		Headers( ): $mol_textarea
		Headers_label( ): $mol_labeler
		headers_label_visible( ): readonly(any)[]
		head_code( next?: string ): string
		Head_code( ): $mol_textarea
		Head_code_label( ): $mol_labeler
		rows_code( next?: string ): string
		Rows_code( ): $mol_textarea
		Rows_code_label( ): $mol_labeler
		rows_limit( next?: number ): number
		Rows_limit( ): $mol_number
		Rows_limit_field( ): $mol_form_field
		column_visibility_options( ): readonly(string)[]
		columns_visible( next?: readonly(string)[] ): readonly(string)[]
		Columns_visibility( ): $shm_check_list
		Columns_visibility_field( ): $mol_form_field
		controls( ): readonly(any)[]
		controlled_settings_content( ): readonly(any)[]
	}
	
}

//# sourceMappingURL=table.view.tree.d.ts.map